import React from "react";
import {
    Box,
    Button,
    Flex,
    Link,
    SimpleGrid,
    Spacer
} from "@chakra-ui/react";


import "../styles/cardgrid.css";

import Card from "./Card";

import { FaChevronCircleRight } from "react-icons/fa";


function GridItem(props) {
    const { item, ...rest } = props

    return (
        <Card {...rest}>
            <Flex className="grid-content" flexDirection={"column"}>
                <h1>{item.title}</h1>
                <p>{item.content}</p>
                <Spacer />
                {item.url == undefined ?
                    <></> :
                    <Link href={item.url} target={"_blank"}>
                        <Button>Learn More<pre> </pre><FaChevronCircleRight /></Button>
                    </Link>
                }
            </Flex>
        </Card>
    );
}

export default function Grid(props) {
    const { className="", items = [], title, subtitle, component = { "type": GridItem }, columns = { "base": 1, "md": 3 }, limit=0, ...rest } = props;

    return (
        <section className={"content " + className} {...rest}>
            <Flex className={"container"} direction={"column"}>
                {title == undefined ?
                    <></> :
                    <h1 className={"title"}>{title}</h1>
                }
                {subtitle == undefined ?
                    <></> :
                    <h2>{subtitle}</h2>
                }
                <SimpleGrid className={"grid"} columns={columns}>
                    {limit > 0 ?
                        items.slice(0, limit).map((item, i) => (
                            <component.type key={i} item={item} />
                        )) :
                        items.map((item, i) => (
                            <component.type key={i} item={item} />
                        ))
                    }
                </SimpleGrid>
            </Flex>
        </section>
    );
}
